<template>
  <div class="chart-container">
    <b-card
      border-variant="light"
      class="text-center chart-card"
      body-class="chart-body"
      header-class="chart-header"
    >
      <template v-slot:header>
        <b-container class="p-0">
          <b-row class="m-0">
            <b-col class="p-2" >
              <!-- Two buttons above plot container on /plot page -->
              <b-btn
                id="v-step-4"
                variant="outline-primary"
                size="sm"
                :to="{ path: `/plot/${chart.i}`, query: chart.query }"
              >
                <i class="far fa-edit"></i> Create/Edit Plot
              </b-btn>
              <b-btn
                id="v-step-5"
                variant="outline-danger"
                size="sm"
                v-b-modal="`confirm-modal-${chart.i}`"
              >
                <i class="far fa-trash-alt"></i> Remove plot
              </b-btn>
              <b-modal
                :id="`confirm-modal-${chart.i}`"
                centered
                lazy
                title="Remove plot">
                <p>
                  Are you sure you want to delete the beautiful plot you just made?
                </p>
                <p>
                  <strong>Removing plot will permanently delete it.</strong>
                </p>
                <!-- @click="deleteChart(chart.i)" -->
                <template #modal-footer="{ cancel }">
                  <b-button size="sm" variant="primary" @click="cancel()">
                    Forget it
                  </b-button>
                  <!-- Button with custom close trigger value -->
                  <b-button size="sm" variant="danger" @click="deleteChart(chart.i)">
                    Delete it!
                  </b-button>
                </template>
              </b-modal>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <!--This is the actual plot-->
      <reactive-plot
        :chartId="`${chart.i}-panel-plot`"
        :chartUUID="chart.i"
        class="plotly-chart-container"
      ></reactive-plot>
      <b-overlay :show="plotLoading" rounded="sm" no-wrap>
        <template v-slot:overlay>
          <b-row>
            <b-col>
              <!-- <div class="text-center"> -->
                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                <br />
                <div id="datastatus-label" v-if="dataStatus !== null">
                  <p>{{ dataStatus }}</p>
                  <p v-if="timeElapsed">Time elapsed: {{ timeElapsed }}</p>
                </div>
              <!-- </div> -->
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col>
              <b-btn
                :to="{ path: `/plot/${chart.i}`, query: chart.query }"
                variant="outline-primary"
                size="sm"
              >
                <i class="fas fa-edit fa-sm"></i>
                Back to data selections
              </b-btn>
              <!--Cancel btn that clears the plot interval and stops the overlay loading-->
              <b-btn
                variant="outline-danger"
                size="sm"
                @click="cancelRequest"
              ><i class="fas fa-exclamation-triangle fa-sm"></i>
                CANCEL
              </b-btn>
            </b-col>
          </b-row>
        </template>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
/*

  Plot Container for panel.

*/
import { mapActions } from 'vuex';
import PlotVue from './Plot';

export default {
  props: ['chart'],
  components: {
    'reactive-plot': PlotVue,
  },
  computed: {
    chartLayout() {
      return this.chart.chart.layout;
    },
    chartOptions() {
      return this.chart.chart.options;
    },
    // To update the plotloading when user hits cancel btn
    plotLoading: {
      get() {
        return this.chart.plotLoading;
      },
      set(value) {
        this.updateChartStatus({
          uuid: this.chart.i,
          chartStatus: 'plotLoading',
          value,
        });
      },
    },
    dataStatus() {
      return this.chart.dataStatus;
    },
    timeElapsed() {
      return this.chart.timeElapsed;
    },
  },
  methods: {
    ...mapActions('visualization/charts', ['removeChart', 'updateChartStatus']),
    deleteChart(uuid) {
      this.removeChart({ uuid });
    },
    cancelRequest() {
      clearInterval(this.interval);
      this.plotLoading = false;
    },
  },
};
</script>

<style lang="sass">
.chart-container
  height: 100% !important
  width: 100% !important

.chart-card
  border: none
  height: 100%
  width: 100%

.chart-body
  height: 100% !important
  padding: 10px !important

.chart-header
  padding: 0

.chart-menu
  background: #ffffff !important

.chart-menu-button
  border: none
  color: rgb(73, 80, 86)

.chart-menu-button:hover
  color: rgb(52, 58, 64)
  background: none

.modal-xxl
  max-width: 1600px
</style>
